import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client';

export function createGraphqlCache() {
	return new InMemoryCache({
		typePolicies: {
			// Membership keys are per-user array indexes, not global identities.
			UserTenantRole: { keyFields: false },
			// Signer IDs identify users; invitation keys and status belong to each agreement.
			SigningUser: { keyFields: false },
			// IDs identify template questions, not customer-specific answers.
			AssignmentRiskQuestion: { keyFields: false },
			// Resolved categories/questions reuse template IDs but contain
			// form-specific answers and company-specific context.
			FormCategory: { keyFields: false },
			FormQuestion: { keyFields: false },
		},
		dataIdFromObject: object => {
			switch (object.__typename) {
				case 'UserRole':
					return `${object.id}-${object.role}`;
				default:
					return defaultDataIdFromObject(object);
			}
		},
	});
}
